import React from 'react';
import { Upload } from 'lucide-react';
import type { PluginDefinition } from '@/plugins/types';
import { APP_VERSION } from '@/app/version';

const UploaderPage = React.lazy(
  () => import('@/app/features/uploader/UploaderPage').then((module) => ({ default: module.UploaderPage })),
);

const fallback = (
  <div className="flex h-full items-center justify-center text-muted-foreground text-sm">
    Lädt…
  </div>
);

export const uploaderPlugin: PluginDefinition = {
  id: 'uploader',
  name: 'Sopho Uploader',
  version: APP_VERSION,
  description: 'Dokument-Upload, Klassifikation und Vorschau für Workspace-Dateien.',
  internal: true,
  group: 'data',
  // DevPlan 0139/T3: workspace-bezogenes Inhalts-Tool → WS-Rolle statt Org-Rolle.
  // Upload-Backend verlangt WS-Editor (DocumentController) → Sichtbarkeit = Nutzbarkeit.
  accessControl: { minWorkspaceRole: 'Editor' },
  initializationOrder: 36,
  initialize: () => undefined,
  navigation: [
    {
      id: 'uploader',
      label: 'Sopho Uploader',
      path: '/app/uploader',
      icon: Upload,
      order: 36,
    },
  ],
  routes: [
    {
      id: 'uploader',
      path: 'uploader',
      element: <React.Suspense fallback={fallback}><UploaderPage /></React.Suspense>,
    },
  ],
};